import { render } from "./agentCalendar.vue?vue&type=template&id=5c22e5ea"
import script from "./agentCalendar.vue?vue&type=script&lang=js"
export * from "./agentCalendar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__